// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Composite API
 * HTTP API for managing Neo4j composite database instances.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface HandlersPatchCompositeInstanceInternalRequest
 */
export interface HandlersPatchCompositeInstanceInternalRequest {
  /**
   *
   * @type {string}
   * @memberof HandlersPatchCompositeInstanceInternalRequest
   */
  memory?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersPatchCompositeInstanceInternalRequest
   */
  neo4jVersion?: string;
}

/**
 * Check if a given object implements the HandlersPatchCompositeInstanceInternalRequest interface.
 */
export function instanceOfHandlersPatchCompositeInstanceInternalRequest(
  value: object,
): value is HandlersPatchCompositeInstanceInternalRequest {
  return true;
}

export function HandlersPatchCompositeInstanceInternalRequestFromJSON(
  json: any,
): HandlersPatchCompositeInstanceInternalRequest {
  return HandlersPatchCompositeInstanceInternalRequestFromJSONTyped(
    json,
    false,
  );
}

export function HandlersPatchCompositeInstanceInternalRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlersPatchCompositeInstanceInternalRequest {
  if (json == null) {
    return json;
  }
  return {
    memory: json['memory'] == null ? undefined : json['memory'],
    neo4jVersion:
      json['neo4jVersion'] == null ? undefined : json['neo4jVersion'],
  };
}

export function HandlersPatchCompositeInstanceInternalRequestToJSON(
  json: any,
): HandlersPatchCompositeInstanceInternalRequest {
  return HandlersPatchCompositeInstanceInternalRequestToJSONTyped(json, false);
}

export function HandlersPatchCompositeInstanceInternalRequestToJSONTyped(
  value?: HandlersPatchCompositeInstanceInternalRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    memory: value['memory'],
    neo4jVersion: value['neo4jVersion'],
  };
}
